import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { whenOfficeReady } from '@slideforge/host-bridge';
import { App } from './App.js';
import { I18nProvider } from './i18n/context.js';
import './styles.css';

/**
 * Mounts once, whether or not Office ever signals ready.
 *
 * `whenOfficeReady` resolves on a timeout when the page is opened outside
 * PowerPoint or the host script is blocked, so the author sees the "SlideForge
 * runs inside PowerPoint" screen instead of a permanently white pane.
 */
async function bootstrap(): Promise<void> {
  await whenOfficeReady();
  const container = document.getElementById('root');
  if (!container) return;
  createRoot(container).render(
    <StrictMode>
      <I18nProvider>
        <App />
      </I18nProvider>
    </StrictMode>,
  );
}

void bootstrap();
